import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../../components/Layout";

const { displayName } = config;

export default function UsersCreate(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Users Create`;
  }, []);

  return (
    <Layout>
      {/* <UsersCreateContent /> */}
      test
    </Layout>
  );
}
